module.exports = __webpack_public_path__ + "static/img/logo_white.23d8a90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon/logo_white.png
// module id = 0GCG
// module chunks = 11